import axios from "axios"

export const teacher = {
    state: () => ({
        teachers: [],
    }),
    getters: {
        teachers(state){
            return state.teachers
        },
    },

    mutations:{
        teachers(state,payload){
            state.teachers = payload
        },
    },

    actions:{
        allTeacher(context){
            axios.get(`${context.getters.url}/teacher/all`,{
                headers: context.getters.header
            })
            .then(res=> {
                if (res.status==200){
                    context.commit('teachers',res.data)
                }
            })
        },
    }
}
